import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Container from 'components/Container';
import NextLink from 'components/NextLink';
import PlayButton from 'components/PlayButton';
import VideoContainer from 'components/VideoContainer';

import CommonPropTypes from 'utils/propTypes/common';
import { makeMovieSlides } from 'utils/helpers/movies';

import styles from './styles.module.scss';

const RecommendationPreview = ({ data, url, subtitle, footer, ...props }) => {
	const slides = makeMovieSlides(data.materials, data.type);

	return (
		<VideoContainer {...data} {...props} slides={slides}>
			{(onPlayButtonClick, slide) => (
				<Container
					className={cx(styles.preview, 'pvi-no-styles')}
					innerClassName={cx(styles.inner, 'pvi-no-styles')}
				>
					<div className={cx(styles.block, 'pvi-no-styles')}>
						<div className={styles.title}>
							<NextLink className={styles.link} href={url}>
								{data.title}
							</NextLink>
						</div>
						{subtitle && <div className={styles.subtitle}>{subtitle}</div>}
						<div
							className={cx(styles.more, 'pvi-no-styles')}
							data-player="start"
						>
							<PlayButton
								key={url}
								publishDate={data.publishDate}
								toDate={data.toDate}
								onClick={onPlayButtonClick}
								text={slide && slide.title}
							/>
						</div>
					</div>
					{footer && <div className={styles.footer}>{footer}</div>}
				</Container>
			)}
		</VideoContainer>
	);
};

RecommendationPreview.propTypes = {
	data: CommonPropTypes.entity.isRequired,
	url: PropTypes.string.isRequired,
	subtitle: PropTypes.node,
	footer: PropTypes.node
};

export default RecommendationPreview;
